import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Route, Routes, useLocation } from "react-router-dom";
import { AppContext } from "../../context/AppContextProvider";
import HaqtAppBar from "../../components/HaqtAppBar/HaqtAppBar";
import HaqtDrawer from "../../components/HaqtDrawer/HaqtDrawer";
import HaqtBreadcrumb from "../../components/HaqtBreadcrumb/HaqtBreadcrumb";
import HaqtSpinner from "../../components/HaqtSpinner/HaqtSpinner";
import MapView from "../../pages/MapView/MapView";
// import SystemData from "../../pages/Datascreen/SystemData";
import Haqt404Page from "../../components/Haqt404Error/Haqt404Page";
import { MQTTClient, MqttProvider } from "@visualsource/react-use-paho-mqtt";
import { getClientId } from "../../services/LoginServices";
import MaintenanceCalendar from "../../pages/WorkOrder/MaintenanceCalendar";

// Page routes
const Dashboard = React.lazy(() => import("../../pages/Dashboard/Dashboard"));

const SystemData = React.lazy(
  () => import("../../pages/Datascreen/SystemData"),
);

const WorkOrder = React.lazy(
  () => import("../../pages/WorkOrder/WorkOrderComponent"),
);
const WorkOrderListComponent = React.lazy(
  () => import("../../pages/WorkOrder/WorkOrderListComponent"),
);
const MaintenanceCalendarComponent = React.lazy(
  () => import("../../pages/WorkOrder/MaintenanceCalendar"),
);

const TenantListComponent = React.lazy(
  () => import("../../pages/Tenants/TenantListComponent"),
);
const SiteComponent = React.lazy(
  () => import("../../pages/Tenants/SiteComponent"),
);

const TenantComponent = React.lazy(
  () => import("../../pages/Tenants/TenantComponent"),
);
const Charts = React.lazy(() => import("../../pages/Charts/index"));
const SystemStatus = React.lazy(
  () => import("../../pages/SystemStatus/SystemStatus"),
);
const DashboardCustomisation = React.lazy(
  () => import("../../pages/DashboardCustomisation/DashboardCustomisation"),
);
const DashboardCustomForm = React.lazy(
  () => import("../../pages/DashboardCustomisation/DashboardCustomForm"),
);
const PredefinedSetting = React.lazy(
  () => import("../../pages/PredefinedSetting/PredefinedSetting"),
);

const PredefinedSettingList = React.lazy(
  () => import("../../pages/PredefinedSetting/PredefinedSettingList"),
);
const Alarms = React.lazy(() => import("../../pages/Alarms/Alarms"));

const ImageParameters = React.lazy(
  () => import("../../pages/ImageParameters/ImageParameters"),
);

const AdminLayout = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  // const [clientId, setClientId] = React.useState(null);
  // const [client, setClient] = React.useState(null);
  const { showSpinner, isAdminUser } = useContext(AppContext);
  const location = useLocation();
  /*
  useEffect(() => {
    fetchClientId();
  },[]);

  const fetchClientId = async () => {
    const response = await getClientId(); 
    if (response && response.data) {
      setClientId(response.data.clientId);
    }
  };

  useEffect(() => {
    if(clientId){
      connectMQTT();
    }
  },[clientId]);
  
  const OnConnectSuccess = () => {
    console.log("Connected to MQTT Server");
  };
  const OnConnectError = (message) => {
    console.log("Connection to MQTT Server failed: " + message.errorMessage);
  };

  const connectMQTT = () => {
    // Paho Client initialization
    const client = new MQTTClient({
      invocationContext: {
        host: process.env.REACT_APP_MQTT_HOST,
        port: parseInt(process.env.REACT_APP_MQTT_PORT),
        path: "/mqtt",
        clientId: clientId
      },
      host: process.env.REACT_APP_MQTT_HOST,
      useSSL: true,
      port: parseInt(process.env.REACT_APP_MQTT_PORT),
      userName: "admin",
      password: "password",
      // path: "/mqtt",
      // mqttVersion: 4,

      // host: "test.mosquitto.org",
      // useSSL: true,
      // port: 8091,
      // userName: "ro",
      // password: "readonly",

      timeout: 5,
      keepAliveInterval: 100,
      cleanSession: false,
      onSuccess: OnConnectSuccess,
      onFailure: OnConnectError,
      clientId: clientId
    });

    setClient(client);
  };
*/
  const container =
    window !== undefined ? () => window().document.body : undefined;

  const drawerWidth = 275;

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    // client && <MqttProvider client={client}>
    //  <MqttProvider client={"haqt"}>
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <HaqtAppBar
        drawerWidth={drawerWidth}
        drawerOpen={drawerOpen}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
      />

      <Box sx={{ display: "flex", width: "100%", minHeight: "100vh" }}>
        {location.pathname !== "/admin/maps" && location.pathname !== "/" && (
          <HaqtDrawer
            drawerWidth={drawerWidth}
            drawerOpen={drawerOpen}
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
          />
        )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: 0.5, //{ xs: 1, sm: 1, md: 2 },
            pt: 8.5,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            background: "#F3F3F3",
            display: "flex",
            flexDirection: "column",
            // overflow: "auto"
          }}
        >
          {location.pathname !== "/admin/maps" && location.pathname !== "/" && (
            <HaqtBreadcrumb />
          )}

          <Box sx={{ flexGrow: 1 }}>
            <React.Suspense fallback={<></>}>
              <Routes>
                <Route path="/" element={<MapView />} />
                <Route path="/maps" element={<MapView />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dataoverview" element={<SystemData />} />
                <Route
                  path="/tenant/add"
                  element={
                    isAdminUser ? (
                      <TenantComponent mode="add" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
                <Route
                  path="/tenant/:tenantId/view"
                  element={
                    isAdminUser ? (
                      <TenantComponent mode="view" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
                <Route
                  path="/tenant/:tenantId/edit"
                  element={
                    isAdminUser ? (
                      <TenantComponent mode="edit" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
                <Route
                  path="/tenant/list"
                  element={
                    isAdminUser ? <TenantListComponent /> : <Haqt404Page />
                  }
                />
                <Route
                  path="/site/add"
                  element={
                    isAdminUser ? <SiteComponent mode="add" /> : <Haqt404Page />
                  }
                />
                <Route
                  path="/site/:siteId/view"
                  element={
                    isAdminUser ? (
                      <SiteComponent mode="view" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
                <Route
                  path="/site/:siteId/edit"
                  element={
                    isAdminUser ? (
                      <SiteComponent mode="edit" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
                <Route path="/systemstatus" element={<SystemStatus />} />
                <Route
                  path="/parameters/add"
                  element={
                    isAdminUser ? (
                      <PredefinedSetting mode="add" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
                <Route
                  path="/parameters/:configId/view"
                  element={
                    isAdminUser ? (
                      <PredefinedSetting mode="view" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
                <Route
                  path="/parameters/:configId/edit"
                  element={
                    isAdminUser ? (
                      <PredefinedSetting mode="edit" />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />

                <Route
                  path="/parameters/list"
                  element={
                    isAdminUser ? <PredefinedSettingList /> : <Haqt404Page />
                  }
                />
                <Route path="/chartinsights" element={<Charts />} />
                <Route path="/alarmshistory" element={<Alarms />} />

                <Route
                  path="/dashboardmanagement"
                  element={
                    isAdminUser ? <DashboardCustomisation /> : <Haqt404Page />
                  }
                />
                <Route
                  path="/dashboardmanagement/add"
                  element={
                    isAdminUser ? <DashboardCustomForm /> : <Haqt404Page />
                  }
                />
                <Route
                  path="/dashboardmanagement/:custId/view"
                  element={
                    isAdminUser ? <DashboardCustomForm /> : <Haqt404Page />
                  }
                />
                <Route
                  path="/dashboardmanagement/:custId/edit"
                  element={
                    isAdminUser ? <DashboardCustomForm /> : <Haqt404Page />
                  }
                />
                <Route
                  path="/imageparameters"
                  element={isAdminUser ? <ImageParameters /> : <Haqt404Page />}
                />
                <Route
                  path="/workorder/list"
                  element={
                    isAdminUser ? <WorkOrderListComponent /> : <Haqt404Page />
                  }
                />
                <Route
                  path="/workorder/add"
                  element={isAdminUser ? <WorkOrder /> : <Haqt404Page />}
                />
                <Route
                  path="/workorder/:workOrderID/view"
                  element={isAdminUser ? <WorkOrder /> : <Haqt404Page />}
                />
                <Route
                  path="/workorder/:workOrderID/edit"
                  element={isAdminUser ? <WorkOrder /> : <Haqt404Page />}
                />
                <Route
                  path="/workorder/schedule"
                  element={
                    isAdminUser ? (
                      <MaintenanceCalendarComponent />
                    ) : (
                      <Haqt404Page />
                    )
                  }
                />
              </Routes>
            </React.Suspense>
          </Box>
          {showSpinner && <HaqtSpinner />}
        </Box>
      </Box>
    </Box>
    //  </MqttProvider>
  );
};

export default AdminLayout;

AdminLayout.propTypes = {
  window: PropTypes.func,
};
